import {Injectable} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';

@Injectable()
export class FieldValidationService {

  form_fields: any[] = []

  public errors: string[] = [];

  constructor(private t: TranslocoService) {
  }

  SetFields(form_fields: any[]) {
    this.form_fields = form_fields;
  }

  Validate(): boolean {
    let valid = true;
    this.form_fields.forEach((field: any) => {
      switch (field.field_type) {
        case 'textfield':
          const urlRegExp = /^(https:\/\/)?(www\.)?[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,5}[.]?/;

          if (field.input_type === 'url'
            && (field.field_value !== '')
            && !urlRegExp.test(field.field_value)
          ) {
            valid = false;
            this.addError(field, this.t.translate('Please, press the Preview Form and input the correct url or left it empty'))
          }

          if (
            field.layout === 'horizontal'
            &&
            (!field.labelWidth || field.labelWidth < 10 || field.labelWidth > 90)
          ) {
            valid = false;
            this.addError(field, this.t.translate('Label width should be between 10 and 90'))
          }
          break;
        case 'dropdown':
          const f = field;
          if (f.load_dynamically && f.load_dynamically === true) {
            f.field_options = [];
            f.calculate_by_additional_val = false;
            if (!f.data_url) {
              valid = false;
              this.addError(field, this.t.translate('Data URL is required'))
              break;
            }
          } else {
            f.enable_linked_list = false
            f.linked_list = null
            f.load_dynamically = false
            f.data_url = ""
            if(!this.checkOptions(field)) {
              valid = false;
            }
          }
          if (f.enable_linked_list && f.enable_linked_list === true) {
            if (isNaN(Number(f.linked_list))) {
              valid = false;
              this.addError(field, this.t.translate('Linked List should be selected'))
              break;
            }
          }
          break;
        case 'checkbox':
        case 'radio':
        case 'multiple_selection':
          if(!this.checkOptions(field)) {
            valid = false;
          }
          break
        case 'scale':
          const minValue = Math.abs(field.min_scale_value);
          const maxValue = Math.abs(field.max_scale_value);

          if (
            typeof minValue == "undefined" || typeof maxValue == "undefined"
            ||
            (String(minValue)).trim() === "" || String(maxValue).trim() === ""
            ||
            isNaN(minValue) || isNaN(maxValue)
          ) {
            this.addError(field, this.t.translate('Min and Max scale values are required'))
            valid = false;
            break;
          }

          if (!/^\d+$/.test(String(minValue)) || !/^\d+$/.test(String(maxValue))) {
            this.addError(field, this.t.translate('Min and Max scale values should be integer only'))
            valid = false;
            break;
          }

          break;
        case 'calculated_field':

          if (typeof field == "undefined"
            || typeof field.selected_fields == "undefined"
            || typeof field.operation == "undefined"
          ) {
            valid = false;
            this.addError(field, this.t.translate('Calculated field internal error.'))
          }

          if (field.selected_fields.length === 0) {
            valid = false;
            this.addError(field, this.t.translate('Please, select at least one field to calculate.'))
          }

          if (field.operation === '') {
            valid = false;
            this.addError(field, this.t.translate('Please, select an operation type.'))
          }

          break;
        case 'duplicate_block':
          const invalidDuplicatedValue = typeof field.field_value == "undefined"
            ||
            (typeof field.field_value === "string" && field.field_value.trim() === "")
            ||
            field.field_value.length === 0;
          if (invalidDuplicatedValue) {
            valid = false;
            this.addError(field, this.t.translate('Please, select at least one field to duplicate.'))
          }
          break;
        case 'signature':
          if (field.required_employee_signature
            && (
              typeof field.related_employee_picker_id == "undefined"
              ||
              (typeof field.related_employee_picker_id === "string" && field.related_employee_picker_id.trim() === "")
              ||
              isNaN(field.related_employee_picker_id)
            )
          ) {
            valid = false;
            this.addError(field, this.t.translate('Please, assign "Employee Picker" to the Signature Field or turn off "Require Employee Signature"'))
          }

          break;
        case 'selected_employee_information':
          if (
            typeof field.related_employee_picker_id == "undefined"
            ||
            (typeof field.related_employee_picker_id === "string" && field.related_employee_picker_id.trim() === "")
            || isNaN(field.related_employee_picker_id)
          ) {
            valid = false;
            this.addError(field, this.t.translate('Please, assign "Employee Picker" to the "Selected Employee Information"'))
          }
          break;

        default:
          break;
      }
    })
    return valid;
  }

  private checkOptions(field: any): boolean {
    if(!Array.isArray(field.field_options) || (Array.isArray(field.field_options) && field.field_options.length === 0)) {
      this.addError(field, this.t.translate('Options are required for this element'))
      return false;
    }
    let _valid = true;
    field.field_options.forEach((option: any) => {
      if (
        _valid
        &&
        typeof option != "undefined" && typeof option.option_title != "undefined"
        &&
        option.option_title.trim() === ''
      ) {
        _valid = false
        this.addError(field, this.t.translate('A title is required for this element'))
      }
    });
    return _valid;
  }

  private addError(field: any, error: string) {
    this.errors.push(
      this.t.translate('Field ')
      + "#" + field.field_id + " "
      + field.field_title + ': '
      + error
    )
  }
}
